import { Injectable, inject } from '@angular/core'
import { ModalService } from 'src/shared/modal/modal.service'
import { FutureBidsListOverlayComponent, FutureBidsListOverlayOptions } from './future-bids-list-overlay.component'

@Injectable()
export class FutureBidsListOverlayService {
  private modal = inject(ModalService)


  showBids(row: any) {
    return this.modal.openDialog<FutureBidsListOverlayComponent, FutureBidsListOverlayOptions, void>(
      FutureBidsListOverlayComponent,
      { row },
      { panelClass: ['tc-dialog', 'modal-xlg'], width: null, maxWidth: null }
    )
  }
}


